import { cn } from '@/lib/cn';

export type SaveMode = 'saved' | 'saving' | 'memory' | 'error';

const MAP: Record<SaveMode, { label: string; color: string }> = {
  saved: { label: 'SAVED', color: 'var(--success)' },
  saving: { label: 'SAVING', color: 'var(--ember)' },
  memory: { label: 'MEMORY', color: '#8a6a3a' },
  error: { label: 'ERROR', color: 'var(--danger)' },
};

/** 상단 저장 상태 표시. M1에서 store의 saveState에 연결됨. */
export function SaveStateIndicator({ mode = 'saved' }: { mode?: SaveMode }) {
  const { label, color } = MAP[mode];
  return (
    <div
      className="flex items-center gap-[7px] font-mono text-[10.5px] uppercase tracking-[0.12em] text-faint"
      role="status"
      aria-live="polite"
    >
      <span
        className={cn('size-[7px] rounded-full transition', mode === 'saving' && 'animate-pulse')}
        style={{ background: color, boxShadow: `0 0 8px ${color}` }}
      />
      <span className="hidden sm:inline">{label}</span>
    </div>
  );
}
